import moment from "moment";

export const getEarliestAllowedDate = () => {
  return moment().day(0).subtract(12, "months").startOf("day");
};

export const filterTableData = (data, filters) => {
  if (!data) return [];

  return data.filter((row) => {
    // Significant (>0%) Filter
    if (filters.significantVal !== "All") {
      const isSignificantVal = row.effective_discount_pct > 0;
      if (filters.significantVal === "True" && !isSignificantVal) return false;
      if (filters.significantVal === "False" && isSignificantVal) return false;
    }

    // Steep (>40%) Filter
    if (filters.steepVal !== "All") {
      const isSteepVal = row.max_discount_pct >= 40;
      if (filters.steepVal === "True" && !isSteepVal) return false;
      if (filters.steepVal === "False" && isSteepVal) return false;
    }

    // Storewide Filter
    if (filters.storewide !== "All") {
      const isStorewide = !!row.is_storewide;
      if (filters.storewide === "True" && !isStorewide) return false;
      if (filters.storewide === "False" && isStorewide) return false;
    }

    // Steep Filter
    if (filters.steep !== "All") {
      const isSteep = !!row.is_steep;
      if (filters.steep === "True" && !isSteep) return false;
      if (filters.steep === "False" && isSteep) return false;
    }

    // Significant Filter
    if (filters.significant !== "All") {
      const isSignificant = !!row.is_significant;
      if (filters.significant === "True" && !isSignificant) return false;
      if (filters.significant === "False" && isSignificant) return false;
    }

    // Clearance Filter
    if (filters.clearance !== "All") {
      const isClearance = !!row.is_clearance;
      if (filters.clearance === "True" && !isClearance) return false;
      if (filters.clearance === "False" && isClearance) return false;
    }

    // Desperation Filter
    if (filters.desperation !== "All") {
      const hasValue = row.nlp_badwords && row.nlp_badwords.length > 0;
      if (filters.desperation === "True" && !hasValue) return false;
      if (filters.desperation === "False" && hasValue) return false;
    }

    return true;
  });
};

export const downloadTableData = (data, filename = "harmonic_data.csv") => {
  if (!data || data.length === 0) {
    alert("No data to download");
    return;
  }

  // Define the columns to include in the CSV (visible columns)
  const columns = [
    { label: "Subject", key: "subject" },
    { label: "Category", key: "category" },
    { label: "Start Date", key: "start_date" },
    { label: "End Date", key: "end_date" },
    { label: "Volume", key: "total_volume" },
    { label: "Min %", key: "min_discount_pct" },
    { label: "Max %", key: "max_discount_pct" },
    { label: "Effective %", key: "effective_discount_pct" },
    { label: "State", key: "state_discount" },
    { label: "State Discount Value", key: "state_discount_val" },
    { label: "Storewide", key: "is_storewide" },
    { label: "Steep", key: "is_steep" },
    { label: "Significant", key: "is_significant" },
    { label: "Clearance", key: "is_clearance" },
    { label: "Desperation", key: "nlp_badwords" },
  ];

  // Helper to escape CSV values
  const escapeCsvValue = (value) => {
    if (value === null || value === undefined) return "";
    const stringValue = String(value);
    if (stringValue.includes(",") || stringValue.includes('"') || stringValue.includes("\n")) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  // Generate CSV content
  const headerRow = columns.map((col) => escapeCsvValue(col.label)).join(",");
  const rows = data.map((row) =>
    columns.map((col) => escapeCsvValue(row[col.key])).join(",")
  );
  const csvContent = [headerRow, ...rows].join("\n");

  // Create download link
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
